import React, { Component } from "react";
import Fade from "react-reveal";
import "./style.css";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const name = this.props.data.name;
    const profilepic = "images/" + this.props.data.image;
    const bio = this.props.data.bio;
    const street = this.props.data.address.street;
    const city = this.props.data.address.city;
    const state = this.props.data.address.state;
    const zip = this.props.data.address.zip;
    const phone = this.props.data.phone;
    const email = this.props.data.email;
    const resumeDownload = this.props.data.resumedownload;

    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img src={profilepic} alt="riding a cycle" />
            </div>
            <div className="nine columns main-col">
              <h2 style={{ color: " rgba(0, 148, 141, 0.678)" }}>
                What is EGRE MENGED?
              </h2>
              <p style={{ color: "black" }}>{bio}</p>
              <div className="row">
                <div className="columns contact-details">
                  <h2 style={{ color: " rgba(0, 148, 141, 0.678)" }}>
                    Contact Details
                  </h2>
                  <p className="address">
                    <span style={{ color: "black" }}>{name}</span>
                    <br />
                    <span style={{ color: "black" }}>
                      ----
                      <br />
                      Addis Ababa ,Ethiopia
                    </span>
                    <br />
                    <span style={{ color: "black" }}>{phone}</span>
                    <br />
                    <span style={{ color: "black" }}>{email}</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href={resumeDownload} className="button">
                      <i className="fa fa-download"></i>Download Brochure
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
